import { Component } from '@angular/core';

@Component({
  selector: 'fgb-games-layout',
  templateUrl: './games-layout.component.html',
  styleUrl: './games-layout.component.scss',
})
export class GamesLayoutComponent {}
